export interface DiscussionOverview {
  uuid: string;
  time: string;
  name: string;
  unread: boolean;
  message: string;
}

export interface DiscussionMessage {
  time: string;
  isMine: boolean;
  message: string;
  attachments: Array<{
    href: string;
    name: string;
  }>;
}

export interface DiscussionMessageToSend {
  message?: string;
  attachment?: {
    data: string;
    filename: string;
    mimetype: string;
    filesize: number;
  };
}

export interface MessagesContact {
  uuid: string;
  name: string;
  conversationHref?: string;
}

export interface Discussion {
  uuid: string;
  name: string;
  isPro: boolean;
  amIMuted: boolean;
  isMyContact: boolean;
  messages: Array<DiscussionMessage>;
}

export interface Discussions {
  atLeastOneUnread: boolean;
  discussions: Array<DiscussionOverview>;
}
